<template>
    <div>
      {{unidades}}
      <LineChartGenerator
      :chart-options="chartOptionsMutado"
      :chart-data="chartData"
    />
    </div>
   
  </template>
  
  <script>
  import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
  import zoomPlugin from 'chartjs-plugin-zoom';
  
  import annotationPlugin from 'chartjs-plugin-annotation';
  import {mapState} from 'vuex'
  import 'chartjs-adapter-moment';
  
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale,
    Legend,
    TimeScale
  
  } from 'chart.js'
  
  ChartJS.register(  Title,
    Tooltip,
    LineElement,
    LinearScale,
    PointElement,
    zoomPlugin,
    Legend,
    annotationPlugin,
    CategoryScale,
    TimeScale
  )
  
    // Deshabilitar la leyenda globalmente
  ChartJS.defaults.plugins.legend.display = false;
  
  export default {
    name: 'LineChart',
    components: {
      LineChartGenerator,
    },
    props: {
      unidades:String,
      chartData: {
        labels:Array,
        datasets: Array,
      },
      plugins: {
        type: Array,
        default: () => []
      },
      tromel:Boolean,
      temp1_configuracion:String,
      temp2_configuracion:String,
    },
    methods: {
      kk(v){
        return `kk ${v}`
      }
    },
    computed: {
      ...mapState([
          'higienizacion1',
          'higienizacion2',
      ]),
      chartOptionsMutado() {
        let thenAnotations = {};
  
        let k = {
          plugins: {
            title: {
              display: true,
              font: {
                size: 18
              }
            },
            legend: {
              display: true,
              position: 'top',
              labels: {
                font: {
                  size: 14
                },
                usePointStyle: true,
              },
              onClick: (event, legendItem, legend) => {
                const chart = legend.chart;
                const datasetIndex = legendItem.datasetIndex;
  
                // Cambia la propiedad hidden del dataset
                chart.data.datasets[datasetIndex].hidden = !chart.data.datasets[datasetIndex].hidden;
  
                // Actualiza el gráfico
                chart.update();
              }
            },
            annotation: thenAnotations,
            zoom: {
              zoom: {
                wheel: {
                  enabled: true,
                },
                pinch: {
                  enabled: true
                },
                mode: 'x',
                pan: {
                  enabled: true
                },
                drag: {
                  enabled: true
                }
              }
            },
            tooltip: {
              enabled: true,
              mode: 'nearest',
              intersect: false,
              callbacks: {
                label: function (context) {
                  const chart = context.chart;
                  const datasets = chart.data.datasets;
                  const mouseX = new Date(context.raw.x).getTime();

                  // Array para almacenar los resultados
                  const interpolatedValues = [];

                  datasets.forEach((dataset, datasetIndex) => {
                    if (dataset.hidden) return; // Ignorar datasets ocultos

                    const data = dataset.data;

                    for (let i = 0; i < data.length - 1; i++) {
                      const currentPoint = data[i];
                      const nextPoint = data[i + 1];
                      const x1 = new Date(currentPoint.x).getTime();
                      const x2 = new Date(nextPoint.x).getTime();

                      // Verifica si el mouseX está entre los dos puntos
                      if (mouseX >= x1 && mouseX <= x2) {
                        const y1 = currentPoint.y;
                        const y2 = nextPoint.y;

                        // Interpolación lineal
                        const interpolatedY = y1 + ((y2 - y1) * (mouseX - x1)) / (x2 - x1);
                        interpolatedValues.push(
                          `${dataset.label || `Dataset ${datasetIndex + 1}`}: ${interpolatedY.toFixed(2)}`
                        );
                        break;
                      }
                    }
                  });

                  // Formatea la fecha para el eje X
                  const formattedDate = new Date(mouseX).toLocaleString('es-ES', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                  });

                  return [`Fecha: ${formattedDate}`, ...interpolatedValues];
                }
              }
            }


          },
          animation: {
            duration: 0
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              type: 'time',
              title: {
                display: true,
                text: 'Horas'
              },
              time: {
                tooltipFormat: 'DD/MM/YYYY HH:mm', // Formato para el tooltip
                displayFormats: {
                  minute: 'DD/MM/YYYY HH:mm', // Formato para los ticks del eje
                  hour: 'DD/MM/YYYY HH:mm',   // Opcional, si se manejan horas
                }
              },
              padding: {
                left: 40,
                right: 40
              }
            },
            y1: {
              id: 'y1',
              title: {
                display: true,
                // text: 'Temperatura (°C) - Trabajo'
              },
              // padding: {
              //   bottom: 100,
              //   top: 100
              // },
              // pan: {
              //   enabled: true,
              //   mode: 'y'
              // },
              ticks: {
                callback: function(value) {
                  return `${value}`;
                }
              }
            },
            y2: {
              id: 'y2',
              position: "right",
              title: {
                display: true,
                // text: 'Energia Acumulada'
              },
              // padding: {
              //   bottom: 100,
              //   top: 100
              // },
              // pan: {
              //   enabled: true,
              //   mode: 'y1'
              // },
              ticks: {
                callback: function(value) {
                  return `${value}`;
                }
              }
            }
          }
        };
  
        return k;
      }
  
    },
  
    data() {
  
      return {
       
  
      }
    },
  }
  </script>